<template>
  <div class="result-11">
    <img
      class="logo"
      src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-02/dd5a05708a56a6dbb01068eb23dbb984_wh=720_64.webp"
      alt=""
    />
    <div class="result-container">
      <div class="result-wrapper">
        <img
          class="iconfont"
          src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-02/3b6763afbc6f0020b6a2b25039480b02_wh=192_192.webp"
          alt=""
        />
        <div class="text">感谢您的填写！</div>
        <div class="desc"
          >您的信息将被严格保密<br />
          仅用于为您提供更好的服务</div
        >
        <div class="close" @click="bindClose">关闭</div>
      </div>
      <img
        class="paper-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8dbd77e6116f63ca18836824ea095fd7.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    bindClose() {
      if (this.$betterwe.isApp()) {
        this.$betterwe.onAppCloseRoute()
      } else {
        window['wx']['closeWindow']()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.result-11 {
  position: relative;
  z-index: 1;
  height: 100vh;
  background-color: rgba(255, 34, 84, 1);
  padding: 18px 20px;
  box-sizing: border-box;
  .logo {
    height: 16px;
    margin-bottom: 12px;
  }
  .result-container {
    .result-wrapper {
      background: #ffffff;
      height: 558px;
      max-height: 558px;
      box-sizing: border-box;
      border-radius: 8px 8px 0px 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 58px 5px 0px;

      .iconfont {
        width: 48px;
        height: 48px;
        margin-bottom: 17px;
      }

      .text {
        font-weight: bold;
        font-size: 24px;
        color: #050b27;
        line-height: 40px;
        margin-bottom: 29px;
      }

      .desc {
        width: 291px;
        height: 80px;
        border-radius: 8px;
        border: 1px dashed rgba(5, 11, 39, 0.5);
        /*  background-image: linear-gradient(to right, rgba(5, 11, 39, 0.5) 1px, rgba(5, 11, 39, 0.5) 1px, rgba(5, 11, 39, 0) 1px, rgba(5, 11, 39, 0) 4px),
          linear-gradient(rgba(5, 11, 39, 0.5) 1px, rgba(5, 11, 39, 0.5) 1px, rgba(5, 11, 39, 0) 1px, rgba(5, 11, 39, 0) 4px),
          linear-gradient(to left, rgba(5, 11, 39, 0.5) 1px, rgba(5, 11, 39, 0.5) 1px, rgba(5, 11, 39, 0) 1px, rgba(5, 11, 39, 0) 4px),
          linear-gradient(to top, rgba(5, 11, 39, 0.5) 1px, rgba(5, 11, 39, 0.5) 1px, rgba(5, 11, 39, 0) 1px, rgba(5, 11, 39, 0) 4px);
        background-position: top, right, bottom, left;
        background-size: 4px 1px, 1px 4px, 4px 1px, 1px 4px;
        background-repeat: repeat-x, repeat-y, repeat-x, repeat-y; */
        font-size: 14px;
        color: rgba(5, 11, 39, 0.5);
        line-height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 81px;
      }

      .close {
        width: 265px;
        height: 44px;
        background: #f1f1f1;
        border-radius: 25px;
        font-weight: bold;
        font-size: 18px;
        color: #050b27;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .paper-image {
      width: 100%;
    }
  }
}

.result-11::after {
  content: '';
  position: absolute;
  width: 100%;
  height: calc(100vh - 292px);
  left: 0;
  bottom: 0px;
  z-index: -1;
  background: linear-gradient(180deg, rgba(249, 249, 249, 0) 0%, #f9f9f9 100%);
}
</style>
